import axios from 'axios';

const updateMeasurementUnitsFromLot = function (target) {
  let row = $(target).parents('tr');
  let lotSelect = row.find('.receipt-product-lot-select');
  let unitSelect = row.find('.receipt-product-unit-select');
  if (lotSelect.val() !== '0') {
    axios
      .get('/product_lot_group_measurement_units', {
        params: { product_lot_id: lotSelect.val() },
      })
      .then((response) => {
        unitSelect.empty();
        $.each(response.data, function (_, unit) {
          unitSelect.append(
            $('<option>', {
              text: unit.name,
              value: unit.id,
            })
          );
        });
        unitSelect.trigger('change');
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }
};

const updateMeasurementUnitsFromProduct = function (
  productSelect,
  modalUnitSelect,
  rowUnitSelect
) {
  axios
    .get('/product_measurement_units', {
      params: { product_id: productSelect.val() },
    })
    .then((response) => {
      modalUnitSelect.empty();
      $.each(response.data, function (_, unit) {
        modalUnitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
      rowUnitSelect.empty();
      rowUnitSelect.trigger('change');
      $.each(response.data, function (_, unit) {
        rowUnitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
    })
    .catch(function (error) {
      console.log(error.response.data);
    });
};

const printStockReceiptLotOnSelect = function (
  lotCode,
  lotSelect,
  productSelect
) {
  if (productSelect.val()) {
    axios
      .get('/product_name_by_id', {
        params: { product_id: productSelect.val() },
      })
      .then((response) => {
        lotSelect.empty();
        let format = lotCode + ' - ' + response.data.name;
        lotSelect.append(new Option(format, 0));
        lotSelect.prop('disabled', true);
        lotSelect.trigger('change');
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }
};

const newStockReceiptLotModal = function (target) {
  let row = $(target).parents('tr');
  let lotModal = row.find('.receipt-lot-modal');
  lotModal.modal('show');
  let productSelect = row.find('.receipt-lot-product-select');
  productSelect.on('change', function (e) {
    let modalUnitSelect = row.find('.receipt-lot-product-unit-select');
    let rowUnitSelect = row.find('.receipt-product-unit-select');
    updateMeasurementUnitsFromProduct(
      productSelect,
      modalUnitSelect,
      rowUnitSelect
    );
  });
  row.find('.create-lot-button').on('click', function (e) {
    let lotSelect = row.find('.receipt-product-lot-select');
    let lotCode = row.find('.stock-receipt-lot-code').val();
    printStockReceiptLotOnSelect(lotCode, lotSelect, productSelect);
    lotModal.modal('hide');
  });
};

const applyReceiptsSelect2 = function () {
  $('.receipt-product-lot-select').select2({
    placeholder: 'Buscar un lote (código o nombre de producto)',
    minimumInputLength: 3,
  });
  $('.receipt-product-location-select').select2({
    placeholder: 'Buscar una ubicación',
  });
  $('.receipt-lot-product-select').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.receipt-product-unit-select').select2({
    placeholder: 'Seleccione una unidad de medida',
  });
  $('.plant-select').select2({
    placeholder: 'Seleccione una o varias plantas o maquilas',
    width: '100%'
  });
};

document.addEventListener('turbolinks:load', function () {
  applyReceiptsSelect2();
  $('.receipt-product-lot-select').on('change', function (e) {
    updateMeasurementUnitsFromLot($(e.currentTarget));
  });
  $('.stock-receipt-lot-modal-button').on('click', function (e) {
    let target = $(e.currentTarget);
    newStockReceiptLotModal(target);
  });
  $('#receipt-products-fields').on('cocoon:after-insert', function () {
    applyReceiptsSelect2();
    $('.receipt-product-lot-select').on('change', function (e) {
      updateMeasurementUnitsFromLot($(e.currentTarget));
    });
    $('.stock-receipt-lot-modal-button').on('click', function (e) {
      let target = $(e.currentTarget);
      newStockReceiptLotModal(target);
    });
  });
});
